import * as React from "react";

function SvgFoxMetrics(props, ref) {
  return (
    <svg
      id="FoxMetrics_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 266.7 200.9"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".FoxMetrics_svg__st0{fill:#e8774a}"}</style>
      <path
        className="FoxMetrics_svg__st0"
        d="M7.9 2.3h60.2v18.3H27.6v18.3H65V57H27.6v35H7.9V2.3zM130.8 0c28 0 48.4 18.4 48.4 47.2 0 28.8-20.4 47.2-48.4 47.2S82.4 76 82.4 47.2C82.4 18.4 102.8 0 130.8 0zm0 76.1c16.9 0 27.9-12.2 27.9-28.9s-11-28.9-27.9-28.9-27.9 12.2-27.9 28.9 11 28.9 27.9 28.9z"
      />
      <path
        d="M7.3 162.1c0 7 .8 14.9 2.4 23.6 29.5-29.2 57.8-37.6 85.6-37.4 5 0 10 .3 15.1.7-32.5-13.6-66.5-16.7-75.6-14.9 2-6.6 3.1-14.9 3.6-23.4-4.5 1.9-8.6 4.1-12.1 6.8-11.8 8.9-18.8 22.3-19 44.6z"
        fill="#fff"
      />
      <path
        className="FoxMetrics_svg__st0"
        d="M255.5 75c-5-9.8-11.6-19.1-19.1-27.3l-.4-.6 30.7-44.8h-24L225.4 32 209.3 8.9l-4.6-6.6h-24.2l23.3 28.6 8.1 11.6L178.6 92H202l20.3-34.4.8-1.3c1.8 2.7 3.4 5.3 5 7.9 25.3 42.3 21.8 71.6-70.1 45.6C112.5 97 68.7 92 38.8 102.7c-32 11.5-48.1 41-33.2 98.2 44.5-50.2 81.7-48 124-42.3 27.6 3.7 57.4 8.9 92.8 1.9 41.4-8.2 49.3-38.2 40.1-68.4-1.8-5.8-4.1-11.5-7-17.1zM95.3 148.3c-27.8-.2-56.1 8.2-85.6 37.4-1.6-8.7-2.4-16.6-2.4-23.6.1-22.3 7.2-35.7 19-44.6 3.5-2.7 7.6-4.9 12.1-6.8-.5 8.5-1.6 16.8-3.6 23.4 9-1.8 43.1 1.3 75.6 14.9-5-.4-10.1-.7-15.1-.7z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgFoxMetrics);
